import { createSlice } from "@reduxjs/toolkit";
import getConsultationCharges from "@custom/rtk-apis/billing/consultation/getConsultationCharges";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getConsultationChargesSlice = createSlice({
  name: "getConsultationChargesSlice",
  initialState,
  reducers: {
    clearConsultationCharges: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getConsultationCharges.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getConsultationCharges.fulfilled, (state, { payload }) => {
        console.log("Fulfilled1231231", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(getConsultationCharges.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getConsultationChargesSlice.reducer;
export const { clearConsultationCharges } = getConsultationChargesSlice.actions;
